import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ShippingContainers_ModuleContextService } from './ShippingContainers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ShippingContainers_shipment_statuses_dd_ComponentContextService {
  private readonly moduleContext: ShippingContainers_ModuleContextService;

  constructor(moduleContext: ShippingContainers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'shipment_statuses_dd',
      type: ComponentType.selector
    }
  }
}